import { Get } from './common'

export const getAllActivityRecords = async (accessToken) => {
    const url = process.env.REACT_APP_BASE_API_ADDRESS + "ActivityRecords";
    return await Get(accessToken, url);
}